module.exports = __webpack_public_path__ + "media/src/pages/MyAccount/Payments/images/discover-37f2dc034b39fcb7c79cdf92e77fa543.svg";